import { COMPETITIVE_AVERAGE_KEY } from '@/app/dashboards/constants';
import { sortBrandsByName } from '@/app/dashboards/utils/dashboard-general.util';
import { BRAND } from '@/models/auth/permissions.enum';
import { CHANNELS } from '@/models/dashboards/channels.enum';
import { useDashboardsStore } from '@/stores/dashboards';
import { useIdentityStore } from '@/stores/identity';
import { useSearchStore } from '@/stores/search';

export function getAllAvailableCompetitorIdsByChannel(reportChannels) {
  const searchStore = useSearchStore();
  const dashboardsStore = useDashboardsStore();
  const dashboardCompetitiveIdentityBrandsByIds =
    dashboardsStore.dashboardCompetitiveIdentityBrands.map((brand) => brand.id);
  return (
    reportChannels?.reduce((acc, channel) => {
      if (CHANNELS[channel]?.competitiveChannelType) {
        acc[channel] =
          searchStore.competitors[CHANNELS[channel].competitiveChannelType]
            ?.filter((competitor) =>
              competitor?.brandDetails?.some((brandDetail) =>
                dashboardCompetitiveIdentityBrandsByIds.includes(brandDetail.brandId),
              ),
            )
            .map((competitor) => competitor.sourceAccountId) ?? [];
      }
      return acc;
    }, {}) ?? {}
  );
}

export function getCompetitorList(competitors, channel) {
  const channels = Array.isArray(channel) ? channel : [channel];
  const allCompetitors = [];

  channels.forEach((ch) => {
    const channelCompetitors =
      competitors[ch]?.map((competitor) => {
        competitor.name = competitor.handle ?? '';
        competitor.avatarUrl = competitor.avatarUrl ?? '';
        return competitor;
      }) ?? [];
    allCompetitors.push(...channelCompetitors);
  });

  const uniqueCompetitors = new Map();
  allCompetitors.forEach((competitor) => {
    if (!uniqueCompetitors.has(competitor.sourceAccountId)) {
      uniqueCompetitors.set(competitor.sourceAccountId, competitor);
    }
  });

  return sortBrandsByName(Array.from(uniqueCompetitors.values()));
}

function canUserAccessCompetitors(brand) {
  const identityStore = useIdentityStore();

  const brandLabel = brand?.label;
  return identityStore.identity?.permissions?.competitive?.[brandLabel]?.can_access_competitors;
}

export function canAccessCompetitor(competitor) {
  if (!competitor?.isCompetitor || competitor?.id === COMPETITIVE_AVERAGE_KEY) {
    return true;
  }

  const identityStore = useIdentityStore();
  const brandDetails = competitor.brandDetails ?? [];

  return brandDetails.some(
    (brand) =>
      canUserAccessCompetitors(identityStore.identityBrandsById[brand.brandId]) ||
      identityStore.guard(
        BRAND.COMPETITIVE.CAN_ACCESS_COMPETITORS,
        identityStore.identityBrandsById[brand.brandId],
      ),
  );
}
